import { render, staticRenderFns } from "./ViewReceivedBy.vue?vue&type=template&id=06188f4e&scoped=true&"
import script from "./ViewReceivedBy.vue?vue&type=script&lang=js&"
export * from "./ViewReceivedBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06188f4e",
  null
  
)

export default component.exports